import React from "react";
import {connect} from "react-redux";
import {
    Breadcrumb,
    Button,
    Table,
    FormControl,
    Row,
    Col,
    Glyphicon,
    Tooltip,
    OverlayTrigger,
    ButtonGroup, SplitButton, MenuItem, ButtonToolbar, DropdownButton
} from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {LinkContainer} from "react-router-bootstrap";
import cloneDeep from "lodash.clonedeep";
import {Event} from "components/Comet";
import Loading from "components/Loading";
import Request from "request";
import locale from "locale";
import PollEdit from "./PollEdit";
import PollResult from "./PollResult";
import StatusPoll from "./StatusPoll";
import "./style";
import axios from "axios";
import { pollsOrderUpdate } from "../../../../api/cp/poll";
import MoveIcon from "../Widgets/components/Icons/MoveIcon";

const ControlOverlay = ({text, id, children}) => {
    return (
        <OverlayTrigger placement="top" overlay={(<Tooltip id={`tooltip-poll${id}`}>{text}</Tooltip>)}>
            {children}
        </OverlayTrigger>
    );
};

class PagePoll extends React.Component {
	state = {
		polls: [],
		filteredPolls: [],
		selectedStreamId: null,
		editPollId: null,
		pollResult: null,
		showPollResultId: null,
		isLoading: true,
        isSaving: false,
	};

	constructor(props, context) {
		super(props, context);

		this.selectStream = this.selectStream.bind(this);

		this.handleCreatePoll = this.handleCreatePoll.bind(this);
		this.handlePollEdit = this.handlePollEdit.bind(this);
		this.handleChangePollStatus = this.handleChangePollStatus.bind(this);
		this.handleDeletePoll = this.handleDeletePoll.bind(this);

		this.onCreatePoll = this.onCreatePoll.bind(this);
		this.onUpdatePoll = this.onUpdatePoll.bind(this);
		this.onDeletePoll = this.onDeletePoll.bind(this);

		this.handleShowPollResult = this.handleShowPollResult.bind(this);
	}

	selectStream(id) {
		// const {event} = this.props;
        //
		// const stream = event.stream.find(stream => parseInt(stream.id) === parseInt(id));
		// const newState = {selectedStreamId: stream.id};

		this.setState({selectedStreamId: id > 0 ? parseInt(id) : null});
		setTimeout(() => this.filterPolls(), 0);
	}

	filterPolls() {
		let filteredPolls = [...this.state.polls];
		const {selectedStreamId} = this.state;
		if (selectedStreamId) {
			filteredPolls = filteredPolls.filter(poll => poll.streamId === selectedStreamId);
		}

		this.setState({filteredPolls: filteredPolls.sort((a, b) => a.order - b.order)});
	}

	handleCreatePoll(type) {
		type = type || 'standard';

		const {event} = this.props;
		const {selectedStreamId} = this.state;
		const isPrivate = 'standard' !== type;

        if (!selectedStreamId) {
            alert('Нужно выбрать зал');

            return;
        }

		const data = {
			type,
			private: isPrivate,
			streamId: selectedStreamId
		}

		Request.post(`/api/cp/event/${event.eventPassword}/poll`, data)
			.then(this.onCreatePoll)
	}

	handlePollEdit(poll) {
		this.setState({editPollId: poll ? poll.id : null})
	}

	handleChangePollStatus(poll, status) {
		const {event} = this.props;

		Request.put(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`, {status})
			.then(this.onUpdatePoll);
	}
	handleDeletePoll(poll) {
		const {event} = this.props;
        const confirmText = 'Опрос будет удалён';

        if (!confirm(confirmText)) {
            return;
        }

		Request.delete(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`)
			.then(this.onDeletePoll)
	}

	onCreatePoll(poll) {
		this.onUpdatePoll(poll);
	}

	onUpdatePoll(poll) {
		const polls = [...this.state.polls];
		const index = polls.findIndex(p => p.id === poll.id);

		if (index >= 0) {
			polls[index] = Object.assign({}, polls[index], poll);
		} else {
			polls.push(poll);
		}

		this.setState({polls});
		this.filterPolls();
	}

	onDeletePoll(poll) {
		const polls = [...this.state.polls];
		const index = polls.findIndex(p => p.id === poll.id);

		if (index >= 0) {
			polls.splice(index, 1);
			this.setState({polls});
			this.filterPolls();
		}
	}

	handleShowPollResult(poll) {
		this.setState({showPollResultId: poll ? poll.id : null});
	}

	componentDidMount() {
		const {event} = this.props;

		this.setState({selectedStreamId: event.stream[0]?.id, isLoading: true});

		Request.get(`/api/cp/event/${event.eventPassword}/poll`)
			.then(polls => {
				this.setState({polls});
				this.filterPolls();
			})
			.catch(() => {  })
			.then(() => this.setState({isLoading: false}))
		;
	}

    uploadPollLogo() {
        const {event} = this.props;
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (!file) {
                alert('Не выбран файл для загрузки');

                return;
            }

            const formData = new FormData();
            formData.append('logo', file);

            await axios.post(`/api/cp/event/${event.eventPassword}/poll/logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            alert('Логотип загружен');
        });

        input.click();
    }
    async deletePollLogo() {
        const {event} = this.props;
        await axios.delete(`/api/cp/event/${event.eventPassword}/poll/logo`);

        alert('Логотип удалён');
    }

    async onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const {filteredPolls, polls} = this.state;
        const {event} = this.props;
        this.setState({ isSaving: true });

        let _filteredPolls = cloneDeep(filteredPolls);
        const _pollsCopy = cloneDeep(filteredPolls);
        const [removed] = _filteredPolls.splice(result.source.index, 1);
        _filteredPolls.splice(result.destination.index, 0, removed);
        _filteredPolls = _filteredPolls.map((poll, order) => ({ ...poll, order }));

        let _polls = cloneDeep(polls);
        _polls = _polls.map((poll) => {
            const _poll = _filteredPolls.find((_poll) => poll.id === _poll.id);

            if (!_poll) {
                return poll;
            }

            return { ...poll, ..._poll };
        });

        this.setState({ filteredPolls: _filteredPolls});

        try {
            await pollsOrderUpdate(event.eventPassword, { sortOrder: _filteredPolls.map(({ id }) => id) });
        } catch (e) {
            console.error(e);
            this.setState({ filteredPolls: _pollsCopy });
        } finally {
            this.setState({ isSaving: false, polls: _polls });
        }
    }

	render() {
		const {event} = this.props;
		const {isLoading, filteredPolls, editPollId, selectedStreamId, showPollResultId, isSaving} = this.state;

		if (isLoading) return <Loading />;

        const getPollStream = (poll) => event.stream.find(s => s.id === poll.streamId);

        let selectedStreamKey;
        if (selectedStreamId) {
            selectedStreamKey = event.stream.find(stream => stream.id === selectedStreamId)?.streamKey;
        } else {
            selectedStreamKey = event.stream[0].streamKey;
        }

        return (
			<section className="PagePoll">
				<Row>
					<Col xs={9}>
						<Breadcrumb>
							<LinkContainer to={`/event/${event.eventPassword}`}>
								<Breadcrumb.Item>
									{locale('mainMenu.interactive')}
								</Breadcrumb.Item>
							</LinkContainer>
							<Breadcrumb.Item active> 
								{locale('mainMenu.interactive.pollsAndVoting')}
							</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
					<Col xs={2}>
						<FormControl componentClass="select" onChange={e => this.selectStream(parseInt(e.target.value))} value={selectedStreamId || ''}>
                            <option value={''}>[Все залы]</option>
							{event.stream.map(stream => <option value={stream.id} key={stream.streamKey}>{stream.description_ru}</option>)}
						</FormControl>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<ButtonToolbar>
							<SplitButton
								title={locale('button.create')}
								id="createTicketButtons"
								onClick={e => this.handleCreatePoll()}
								onSelect={this.handleCreatePoll}
							>
								<MenuItem eventKey={'standard'}>{locale('poll.type.standard')}</MenuItem>
								<MenuItem eventKey={'open'}>{locale('poll.type.open')}</MenuItem>
								<MenuItem eventKey={'rating'}>{locale('poll.type.rating')}</MenuItem>
							</SplitButton>

                            <DropdownButton title="Логотип" id="pollLogo">
                                <MenuItem onClick={() => this.uploadPollLogo()}>Загрузить</MenuItem>
                                <MenuItem onClick={() => this.deletePollLogo()}>Удалить</MenuItem>
                            </DropdownButton>

                            <ButtonGroup>
                                <ControlOverlay text="Открыть QR-код" id="poll-qrcode">
                                    <LinkContainer to={`/event/${event.eventPassword}/offline/stream/${selectedStreamKey}/qr/polls/view-poll-id/active`}>
                                        <Button><Glyphicon glyph="qrcode" /></Button>
                                    </LinkContainer>
                                </ControlOverlay>
                                <ControlOverlay text="Скачать QR-код" id="poll-qrcode-download">
                                    <Button href={`/polls/${event.eventKey}/qr/download?module-active=polls&view-poll-id=active`} target="_blank"><Glyphicon glyph="download-alt" /></Button>
                                </ControlOverlay>
                            </ButtonGroup>
                        </ButtonToolbar>
					</Col>
				</Row>

				<Event event="create:poll" handler={this.onCreatePoll} />
				<Event event="update:poll" handler={this.onUpdatePoll} />
				<Event event="delete:poll" handler={this.onDeletePoll} />

				<PollEdit event={event} pollId={editPollId} onCancel={() => this.handlePollEdit(null)}/>
				<PollResult event={event} pollId={showPollResultId} onCancel={() => this.handleShowPollResult(null)}/>

				<Table>
					<thead>
					<tr>
                        <th width="40" />
						<th width="40">ID</th>
						<th>Опрос</th>
                        <th>Объект</th>
						<th width="40">Тип</th>
						<th width="20%">Зал</th>
						<th width="300">В плеере</th>
						<th width="140" />
						<th width="40" />
						<th width="100" />
						<th width="40" />
					</tr>
					</thead>
					<DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                        <Droppable droppableId="droppable">
                            {(provided) => (
                                <tbody
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {filteredPolls.map((poll, index) =>
                                        <Draggable
                                            key={poll.id}
                                            draggableId={`${poll.id || index}`}
                                            index={index}
                                        >
                                            {(provided) => (
                                                <tr
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <td width={40}><MoveIcon /></td>
                                                    <td width="40">{poll.id}</td>
                                                    <td>{poll.textRu}</td>
                                                    <td>{poll.object}</td>
                                                    <td width="40">{locale('poll.type.' + poll.type)}</td>
                                                    <td width="20%">{getPollStream(poll)?.description_ru || 'Нет'}</td>
                                                    <td width="300"><StatusPoll poll={poll} /></td>
                                                    {/* <td>{({active: 'Идёт опрос', result: 'Результаты'})[poll.status] || ''}</td> */}
                                                    <td width="140">
                                                        <ButtonGroup>
                                                            <ControlOverlay text="Редактировать опрос" id="poll-edit">
                                                                <Button disabled={isSaving} onClick={() => this.handlePollEdit(poll)}><Glyphicon glyph="cog" /></Button>
                                                            </ControlOverlay>
                                                            <ControlOverlay text="Открыть QR-код" id="poll-qrcode">
                                                                <LinkContainer to={`/event/${event.eventPassword}/offline/stream/${getPollStream(poll)?.streamKey}/qr/polls/view-poll-id/${poll?.id}`}>
                                                                    <Button><Glyphicon glyph="qrcode" /></Button>
                                                                </LinkContainer>
                                                            </ControlOverlay>
                                                            <ControlOverlay text="Скачать QR-код" id="poll-qrcode-download">
                                                                <Button href={`/polls/${event.eventKey}/qr/download?module-active=polls&view-poll-id=${poll?.id}`} target="_blank"><Glyphicon glyph="download-alt" /></Button>
                                                            </ControlOverlay>
                                                        </ButtonGroup>
                                                    </td>
                                                    <td width="40">
                                                        {poll.status === 'active' ?
                                                            <ControlOverlay text="Остановить опрос" id="poll-stop">
                                                                <Button disabled={isSaving} onClick={() => this.handleChangePollStatus(poll, 'stop')}><Glyphicon glyph="stop" /></Button>
                                                            </ControlOverlay>
                                                            :
                                                            <ControlOverlay text="Запустить опрос" id="poll-start">
                                                                <Button disabled={isSaving} onClick={() => this.handleChangePollStatus(poll, 'active')}><Glyphicon glyph="play" /></Button>
                                                            </ControlOverlay>
                                                        }
                                                    </td>
                                                    <td width="100">
                                                        <ButtonGroup>
                                                            <ControlOverlay text="Показать результаты" id="poll-results">
                                                                <Button onClick={() => this.handleShowPollResult(poll)}><Glyphicon glyph="signal" /></Button>
                                                            </ControlOverlay>
                                                            {poll.status === 'result' ?
                                                                <ControlOverlay text="Скрыть результаты в плеере" id="poll-player-result-hide">
                                                                    <Button onClick={() => this.handleChangePollStatus(poll, 'stop')}><Glyphicon glyph="stop" /></Button>
                                                                </ControlOverlay>
                                                                :
                                                                <ControlOverlay text="Показать результаты в плеере" id="poll-player-result-show">
                                                                    <Button onClick={() => this.handleChangePollStatus(poll, 'result')}><Glyphicon glyph="list-alt" /></Button>
                                                                </ControlOverlay>
                                                            }
                                                        </ButtonGroup>
                                                    </td>
                                                    <td width="40">
                                                        <ControlOverlay text="Удалить опрос" id="poll-delete">
                                                            <Button disabled={isSaving} onClick={() => this.handleDeletePoll(poll)} bsStyle="danger"><Glyphicon glyph="trash" /></Button>
                                                        </ControlOverlay>
                                                    </td>
                                                </tr>
                                            )}
                                        </Draggable>
                                    )}
                                    {provided.placeholder}
                                </tbody>
                            )}
                        </Droppable>
                    </DragDropContext>
				</Table>
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(PagePoll);
